export const SET_SUBSCRIBER_USER = 'setSubscriberUser';
export const SET_SUBSCRIBER_USER_TIME_ZONE = 'setSubscriberUserTimeZone';
export const UPDATE_SUBSCRIBER_USER = 'updateSubscriberUser';

export const setSubscriberUser = (user) => {
     return {
          type: SET_SUBSCRIBER_USER,
          payload: user,
     };
};

export const setSubscriberUserTimezone = (timezone) => {
     return {
          type: SET_SUBSCRIBER_USER_TIME_ZONE,
          payload: timezone,
     };
};

export const updateSubscriberUser = (payload) => {
     return {
          type: UPDATE_SUBSCRIBER_USER,
          payload,
     };
};
